import { Moon, Sun } from 'lucide-react';

import { Theme } from './theme';

export const THEMES_LIST = {
  [Theme.Dark]: {
    icon: Moon,
    labelKey: 'theme.dark',
    value: Theme.Dark,
  },
  [Theme.Light]: {
    icon: Sun,
    labelKey: 'theme.light',
    value: Theme.Light,
  },
} as const;

export { Theme, THEME_STORAGE_KEY, THEMES } from './theme';
